import { useLocation } from '@tanstack/react-router';

import { usePlayerGamesHistoryQuery } from '@features/user/api/hooks';
import { useGoToGame } from '@features/user/hooks/useGoToGame';
import { PlayerShieldQuickPeekWidget } from '@features/user/ui/PlayerShieldQuickPeek/PlayerShieldQuickPeekWidget';
import { SomePlayerGamesList } from '@features/user/ui/SomePlayerGamesList/SomePlayerGamesList';

type Props = {
  userId: string;
};
export function SomePlayerGamesListWidget({ userId }: Props) {
  const goToGame = useGoToGame(useLocation().pathname);

  const { data: games } = usePlayerGamesHistoryQuery({
    userId,
    limit: 20,
  });

  if (!games) return;

  return (
    <SomePlayerGamesList
      games={games}
      onGameClick={goToGame}
      renderShieldQuickPeek={(userId: string) => <PlayerShieldQuickPeekWidget userId={userId} />}
    />
  );
}
